import React, { useCallback, useEffect, useRef } from 'react';
import { styled } from 'baseui';
import { ANNOTATION_TYPE } from '../../image/labelling/constants';
import useShortcut from '../../image/labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError } from '../../image/labelling/providers/utils/shortcut';
import type { NOTIFICATION_TYPE } from '../constant/constant';
import type { AnnotationLabelT, GenericAnnotationT } from '../types/types';
import SegmentationLabels from './segmentation-labels/segmentation-labels';
import AnnotationLabel from './annotation-label';
import { EmptyMessageContainer } from './styled-components';
const PanelContainer = styled<'div', {
  $height: number;
}>('div', ({
  $height
}) => ({
  maxHeight: `${$height === 0 ? 300 : $height}px`,
  overflow: 'auto'
}));
type PropsT = {
  height: number;
  annotationLabels: AnnotationLabelT[];
  isSegmentation: boolean;
  selectedAnnotationLabel: AnnotationLabelT | undefined | null;
  onSetAnnotationLabel: (a: AnnotationLabelT) => void;
  annotationList: GenericAnnotationT[];
  showNotification: (notificationType: (typeof NOTIFICATION_TYPE)[keyof typeof NOTIFICATION_TYPE], message: string) => void;
};
const LabelContainer = ({
  height,
  annotationLabels,
  isSegmentation,
  selectedAnnotationLabel,
  onSetAnnotationLabel,
  annotationList,
  showNotification
}: PropsT) => {
  const firstAnnotationRef = useRef<HTMLDivElement | null>(null);
  const {
    registerHotKeys
  } = useShortcut();
  const handleSelectFirstLabel = useCallback(() => {
    // @ts-expect-error todo(ts-migration) TS2345 Argument of type 'AnnotationLabelT | undefined' is not assignable to parameter of type 'AnnotationLabelT'.
    onSetAnnotationLabel(annotationLabels[0]);
    firstAnnotationRef.current?.focus?.();
  }, [onSetAnnotationLabel, annotationLabels]);
  useEffect(() => {
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      keys: ['Control', 'a'],
      onAction: handleSelectFirstLabel
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [registerHotKeys, handleSelectFirstLabel]);
  const hasSegmentationTool = (label: AnnotationLabelT) => {
    return label.tools && label.tools.length > 0 ? label.tools.some(tool => tool === ANNOTATION_TYPE.SEGMENTATION) : true;
  };
  return <PanelContainer $height={height}>
      {annotationLabels.length === 0 && <EmptyMessageContainer>No labels available</EmptyMessageContainer>}
      {annotationLabels.map((annotationLabel, index) => {
      const isSelected = annotationLabel.title.toLowerCase() === (selectedAnnotationLabel?.title || '').toLowerCase();
      const selectedAnnotationLabelId = annotationLabels.findIndex(localAnnotationLabel => localAnnotationLabel.title === selectedAnnotationLabel?.title);
      if (isSegmentation && hasSegmentationTool(annotationLabel)) {
        return <SegmentationLabels key={annotationLabel.title} annotationLabels={[annotationLabel]} selectedAnnotationLabel={selectedAnnotationLabel} onSetAnnotationLabel={onSetAnnotationLabel} annotationList={annotationList} showNotification={showNotification} />;
      }
      return <AnnotationLabel key={annotationLabel.title} annotationLabel={annotationLabel} selectedAnnotationLabelId={selectedAnnotationLabelId} isSelected={isSelected} onAnnotationClick={() => {
        onSetAnnotationLabel(annotationLabel);
      }} showNotification={showNotification} ref={index === 0 ? firstAnnotationRef : null} />;
    })}
    </PanelContainer>;
};
export default LabelContainer;